import {Loader as LoaderComponent, LoaderProps} from '@mantine/core'
import "./Loader.css"

export function Loader(props: LoaderProps) {
    return (
        <div className={"loader-container"}>
            <LoaderComponent color={"teal"} size="xl" {...props} />
        </div>
    );

}
